import styled from "styled-components";

export const PageContent = styled.div`
  padding: 10px 20px;
`;
